import React from 'react';
import PageShell from '@/components/PageShell';
import ProcessSection from '@/components/sections/ProcessSection';
import SectionDivider from '@/components/SectionDivider';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import PhotoStrip, { galleryImages as g } from '@/components/PhotoStrip';

const Process = () => (
  <PageShell
    title="How Vapour Blasting Works | The Wet Blasting Process"
    description="A four-step look at how vapour blasting restores alloy, brass and steel parts without warping or surface damage. Christchurch workshop."
    canonicalPath="/process"
    crumbs={[{ name: 'Process', path: '/process' }]}
  >
    <h1 className="sr-only">The Vapour Blasting Process Explained</h1>
    <ProcessSection />
    <SectionDivider />
    <section className="bg-background">
      <div className="container-wide mx-auto px-4 md:px-8">
        <PhotoStrip
          heading="The finish in real life"
          blurb="Uniform satin sheen across alloy, brass and stainless components."
          images={[g.detail, g.fins, g.cases]}
        />
      </div>
    </section>
    <SectionDivider />

    <section className="section-padding bg-background">
      <div className="container-wide mx-auto max-w-3xl text-center">
        <h2 className="font-display text-3xl md:text-4xl font-bold mb-6 text-foreground">
          Why <span className="gradient-text">wet blasting</span> beats sandblasting
        </h2>
        <p className="text-lg text-muted-foreground mb-6">
          Traditional dry blasting can pit alloy, warp thin castings and embed media into soft
          metals. Vapour blasting suspends the abrasive in water — the cushion of liquid means the
          media skims rather than hammers the surface. The result is a uniform satin finish on
          engine cases, carburettors, cylinder heads, alloy wheels and marine fittings, with no
          measurable material removal and no dust.
        </p>
        <p className="text-lg text-muted-foreground mb-8">
          Read the full breakdown in our blog comparison:{' '}
          <Link
            to="/blog/wet-blasting-vs-sandblasting-alloy-parts"
            className="text-primary border-b border-primary/40 hover:border-primary"
          >
            Wet blasting vs sandblasting alloy parts
          </Link>
          .
        </p>
        <Button variant="hero" size="xl" asChild>
          <Link to="/contact">Get a free quote</Link>
        </Button>
      </div>
    </section>
  </PageShell>
);

export default Process;
